<script setup lang="ts"></script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18 8L22 12M22 12L18 16M22 12L11.7 12C11.1674 12.0057 10.639 11.905 10.1458 11.7037C9.65258 11.5025 9.20456 11.2047 8.828 10.828L2 4M2 20L7 15"
      stroke="#1F2937"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
